import ClientId from "data/ClientId";
import SuperRecordActions from "data/SuperRecordActions";
import FileUploadStore from "data/FileUploadStore";
import safeDispatch from "data/util/safeDispatch";
import SuperRecordStore from "data/SuperRecordStore";

export const canSave = () =>
    FileUploadStore.getAllInProgressFiles().length === 0;

export const saveSuperRecord = (key, id, initiatingContext) =>
    safeDispatch({
        type: ClientId.is(id)
            ? SuperRecordActions.START_CREATE
            : SuperRecordActions.START_UPDATE,
        key,
        id,
        initiatingContext,
    }, () =>
        SuperRecordStore.isUnsaved(key, id)
    );



// WEBPACK FOOTER //
// ./app/data/util/saveit.js